
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ServiceNav',
  setup() {
    // 导航栏内容
    const tags = [
      {
        icon: 'el-icon-umbrella',
        index: 'legacy',
        title: '查询遗留物',
      },
      {
        icon: 'el-icon-s-ticket',
        index: 'seat',
        title: '选座值机',
      },
      {
        icon: 'el-icon-files',
        index: 'receipt',
        title: '申请电子发票',
      },
      {
        icon: 'el-icon-bank-card',
        index: 'claim',
        title: '索求理赔',
      },
      {
        icon: 'el-icon-s-data',
        index: 'special_case',
        title: '特殊情况证明',
      },
    ];
    return {
      tags,
    };
  },
});
